import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import SearchStatsContainer from '../../components/SearchStats/SearchStatsContainer';

const SearchStats = ({ location }) => (
    <PageRootWrapper location={location}>
        <SearchStatsContainer />
    </PageRootWrapper>
);

SearchStats.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default SearchStats;
